import { CreateEmailModuleRequestDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface CreateEmailModuleRequestParams {
  moduleName: string
}

export const useCreateEmailModuleRequest = () => {
  const [createEmailModuleRequest, { loading, error }] = useMutation(
    CreateEmailModuleRequestDocument,
    {
      extractorFn: (data) => data.modulesMutations.createModulesEmailModuleRequest,
    }
  )

  const create = (params: CreateEmailModuleRequestParams) => {
    return createEmailModuleRequest({
      variables: {
        moduleName: params.moduleName,
      },
    })
  }

  return {
    create,
    loading,
    error,
  }
}
